import ProfileAvatar from "../ProfileAvatar";
import Utils from "../../common/Utils";
import React from "react";

const ThreeLineItemRender = ({ avatarSize = 32 , media , line1Value , line2Prefix , line2Value , line3Prefix , line3Value }) => {

    return <div className="clearfix">

        <div style={{ display: "inline" }} className="pull-left">
            <ProfileAvatar size={avatarSize} media={media} showFullscreen={false} name={Utils.formatAvatarName(line1Value)}/>
        </div>

        <div className="ml-5">
            <p style={{ fontSize: "small" }} className="mb-0">{line1Value}</p>
            <p style={{ fontSize: "0.8em"}} className="mb-0">{line2Prefix}: {line2Value}</p>
            <p style={{ fontSize: "0.8em"}} className="mb-0">{line3Prefix}: {line3Value}</p>
        </div>

    </div>
};

export default ThreeLineItemRender;


// WEBPACK FOOTER //
// ./src/components/Elements/ThreeLineItemRender.js